import React from 'react'
import ListCardComponentPokemon from '../../Components/ListCardComponentPokemon/ListCardComponentPokemon'
import ListCardAdminComponentPokemon from '../../Components/ListCardComponentPokemon/ListCardAdminComponentPokemon'

const CardsAdmin = () => {
  return (
    // <div className='layout-page layout-cardPage'>


      <div className='shopContainer_body'>
        <ListCardAdminComponentPokemon type='inventary' subType='Public' hasPrice hasCart  />

      </div>


    // </div>
  )
}

export default CardsAdmin